import { render } from "./OpenData.vue?vue&type=template&id=941e6ac2"
const script = {}
script.render = render

export default script